export * from './src/payments-payment-acceptance-configurations-v1-payment-acceptance-configuration-payment-acceptance-configurations.meta.js';
